module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Text/Quote2-f2d6a1ff00ff7fbe1d802f8f66640701.svg";